/** The support address every page, toast and email points users to. */
export const SUPPORT_EMAIL = "support@quiltedehr.com";
